var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-dropdown",
    {
      attrs: {
        overlayClassName: "menu-transform-drop-overlay",
        trigger: ["click"]
      }
    },
    [
      _c(
        "span",
        { staticClass: "right-content__action" },
        [
          _c("icon-font", { attrs: { type: "gb-icon-shuangmoshiqiehuan" } }),
          _c("span", { staticStyle: { padding: "0 8px 0 4px" } }, [
            _vm._v(_vm._s(_vm.changeMenuName))
          ]),
          _c("a-icon", { attrs: { type: "down" } })
        ],
        1
      ),
      _c(
        "a-menu",
        {
          staticStyle: { top: "-4px" },
          attrs: { slot: "overlay" },
          slot: "overlay"
        },
        _vm._l(
          [
            {
              pageTypeName: "全部菜单",
              pageTypeNameEn: "Initial Menu",
              pageTypeNameKr: "초기 메뉴",
              id: undefined
            }
          ].concat(_vm.menus),
          function(item, index) {
            return _c(
              "a-menu-item",
              {
                key: item.id,
                class: { "overlay-menu-item-cur": item.id === _vm.menuCur },
                on: {
                  click: function($event) {
                    return _vm.menuChange(item.id)
                  }
                }
              },
              [
                index === 0
                  ? _c("icon-font", {
                      staticStyle: { color: "#747474" },
                      attrs: { type: "gb-icon-fanhui" }
                    })
                  : index !== 0 && item.typeIcon
                  ? _c("img", {
                      staticStyle: {
                        display: "inline-block",
                        "vertical-align": "middle"
                      },
                      attrs: { src: item.typeIcon, width: "14", alt: "" }
                    })
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(
                      item["pageTypeName" + _vm.langCodes[_vm.currentLang]] ||
                        item["pageTypeName"]
                    ) +
                    " "
                )
              ],
              1
            )
          }
        ),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }